import { Message } from "../message.model";

export interface BodyEntriesPerHourToday {
  fecha: string;
  sucursal: string;
}

export type ResponseEntriesPerHourToday ={
  column_name: ColumnNameEntriesPerHourToday | Message;
}

export interface ColumnNameEntriesPerHourToday {
  "public data": PublicDataEntriesPerHourToday;
}

export interface PublicDataEntriesPerHourToday {
  anio_base:     number;
  anio_anterior: number;
  fechas:        DateEntriesPerHourToday[];
  indicadores:   SummaryEntriesPerHourToday[];
}

export interface DateEntriesPerHourToday {
  Hora:                            number;
  Hoy:                             number;
  Promedio_mismo_dia_mes_anterior: number;
  Dia_similar_anio_anterior:       number;
  Comparacion?:                     string;
}

export interface SummaryEntriesPerHourToday {
  title:      string;
  total:      number;
  porcentaje: number;
  mensaje:    string;
}
